import styled from 'styled-components';

export const StatusDate = styled.p`
  color: #b4b9d9;
  margin: 0 0 10px;
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 160%;
`;
